import network from './network';
import os from './os';
import browser from './browser';
import isMobile from './isMobile';
import game from './game';
import vendorPrefix from './vendorPrefix';

const staticPath = {
  local: 'https://op-wstatic.ncsoft.com',
  op: 'https://op-wstatic.ncsoft.com',
  rc: 'https://rc-wstatic.plaync.co.kr',
  live: 'https://wstatic-cdn.plaync.com'
};

export default {
  staticPath: staticPath[network()],
  network: network(),
  os: os(),
  browsers: browser(),
  isMobile: isMobile(),
  game: game(),
  vendorPrefix: vendorPrefix()
};



// WEBPACK FOOTER //
// ./node_modules/promokit-videoplayer/node_modules/promokit-util/src/location.js